export const LIST_FILTERS = {
  AMOUNT_TYPE: {
    label: 'Amount type',
    options: [
      { value: 'fixed', label: 'fixed' },
      { value: 'non fixed', label: 'non fixed' },
    ],
  },

  TYPE: {
    label: 'Type',
    options: [
      { value: 'trust', label: 'trust' },
      { value: 'stock', label: 'stock' },
    ],
  },

  // PERSONAL INFO FILTER - ADMIN CENTRE
  STATUS: {
    label: 'Status',
    options: [
      { value: 'Active', label: 'Active' },
      { value: 'Inactive', label: 'Inactive' },
    ],
  },

  NOOFDAYS: {
    label: 'Show data for last',
    options: [
      { value: '1', label: '1 day' },
      { value: '3', label: '3 days' },
      { value: '4', label: '4 days' },
      { value: '30', label: '30 days' },
    ],
  },   
}

export const LIST_DYNAMICFILTERS = (label, options) => ({
  label,
  options,
})



// WEBPACK FOOTER //
// ./src/constants/filters.js